

















import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { DynamicPartsImage } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppImage,
    AppLink,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsImage>,
      required: true,
    },
  },
  setup(props) {
    const { FRONTEND_ORIGIN } = useRuntimeConfig();

    // 内部かどうか
    const isSameOrigin = computed((): boolean => {
      return !!props.item.image.url?.includes(FRONTEND_ORIGIN);
    });

    return { isSameOrigin };
  },
});
